import React from "react";
import Popup from "@src/components/UIElements/Popup";
import { useSelector, useDispatch } from "react-redux";
import { showDeleteAddressPopupAction } from "../../store/actions";
import {
  deleteAddressDataAction,
  setActiveAddressAction,
} from "../../../PhysicalAddress/store/actions";

import { Image } from "@src/components/Image";
import { getAwsAssets } from "@src/utils";

import style from "./SelectAddressBottomSheet.module.scss";
import { t } from "i18next";

function DeleteAddress() {
  // DISPATCH
  const dispatch = useDispatch();

  const deleteAddress = (id) => {
    dispatch(deleteAddressDataAction({ addressId: id }));
    if (activeAddress?.id == id) {
      dispatch(setActiveAddressAction(null));
    }
  };
  // SELECTORS

  const actionableAddressId = useSelector(
    (state) => state?.physicalShipmentReducer?.actionableAddressId
  );

  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );

  return (
    <Popup handleClose={() => dispatch(showDeleteAddressPopupAction(false))}>
      <div className={style.DeleteAddress}>
        <Image
          src={getAwsAssets("ClosePrompt.svg", "bottomSheets")}
          className="SVGCoupons"
          height="48"
          width="48"
          alt="X"
        />

        <h2>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.deleteAddressHeading",
            "Delete Address"
          )}
        </h2>
        <p>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.deleteAddressText",
            "Are you sure you want to delete this address"
          )}
          ?
        </p>
        <p>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.deleteAddressNote",
            "Please note: Deleting this address will not delete any pending orders being shipped to this address"
          )}
        </p>
        <button onClick={() => deleteAddress(actionableAddressId)}>
          {t(
            "components.bottomSheets.components.selectAddressBottomSheet.done",
            "DONE"
          )}
        </button>
      </div>
    </Popup>
  );
}

export default DeleteAddress;
